import { useBreadcrumb } from '~/components/layout/Breadcrumb';
import { PageLoader } from '~/components/page/PageLoader';

export default function LimeAitRoute() {
  useBreadcrumb('routes/lime-ait', 'Lime AIT');
  return <PageLoader pageName="lime-ait" />;
}
